import { render, staticRenderFns } from "./SettingsBtn.vue?vue&type=template&id=21bb95f6"
import script from "./SettingsBtn.vue?vue&type=script&lang=ts"
export * from "./SettingsBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports